import React from "react";
import "../ServiceInicio/ServiceInicio.css";
import { Zoom } from "react-awesome-reveal";

import imgFormacion from "../Assets/Img/Copilot_20260306_100322.png";
import imgOnboarding from "../Assets/Img/Copilot_20260306_100704.png";
import imgReclutamiento from "../Assets/Img/Copilot_20260306_100920.png";
import imgChatbot from "../Assets/Img/Copilot_20260306_101215.png";
import imgRoles from "../Assets/Img/tresa.png";
import Header from "../Header/Header.js"
import Footer from "../Footer/Footer.js"

function ModulosPlataforma() {

  const modulos = [
    {
      id: 1,
      titulo: "Plataforma educativa y de capacitación",
      descripcion:
        "Sistema integral para gestionar procesos de formación, capacitaciones y desarrollo profesional dentro de la organización. Permite crear cursos, administrar contenidos, realizar evaluaciones y visualizar el progreso de los participantes mediante tableros de seguimiento.",
      imagen: imgFormacion,
      destacado: true,
      features: [
        "Gestión de cursos y capacitaciones",
        "Contenido multimedia y recursos educativos",
        "Evaluaciones y actividades",
        "Tableros de progreso",
        "Formación asincrónica",
      ],
    },
    {
      id: 2,
      titulo: "Onboarding digital de colaboradores",
      descripcion:
        "Facilita la integración de nuevos colaboradores mediante procesos de onboarding estructurados y automatizados. Permite presentar la cultura organizacional, los procesos internos y los recursos clave desde el primer día.",
      imagen: imgOnboarding,
      features: [
        "Procesos de ingreso automatizados",
        "Presentación de cultura organizacional",
        "Seguimiento del progreso inicial",
        "Material de bienvenida digital",
      ],
    },
    {
      id: 3,
      titulo: "Reclutamiento y selección inteligente",
      descripcion:
        "Optimiza la búsqueda y selección de talento mediante un sistema de postulaciones centralizado. Los candidatos pueden crear su perfil y postularse a vacantes mientras los administradores gestionan procesos de selección de manera ágil.",
      imagen: imgReclutamiento,
      features: [
        "Publicación de vacantes",
        "Perfiles de postulantes",
        "Gestión de candidatos",
        "Búsquedas personalizadas",
      ],
    },
    {
      id: 4,
      titulo: "Chatbot inteligente con IA",
      descripcion:
        "Asistente virtual disponible las 24 horas que responde consultas frecuentes, brinda soporte a usuarios y facilita el acceso a información dentro de la plataforma. Mejora la comunicación y reduce tiempos de respuesta.",
      imagen: imgChatbot,
      features: [
        "Respuestas automáticas",
        "Disponible 24/7",
        "Atención a estudiantes o colaboradores",
        "Integración con la plataforma",
      ],
    },
    
  ];

  return (
    <>
    <Header/>
    <section className="service-section" id="modulos-plataforma">

      <div className="service-container">

        <header className="service-header">
          <span className="service-badge">Módulos de la plataforma</span>
          <h2>Tecnología que impulsa el desarrollo de las organizaciones</h2>
          <p>
            Nuestra plataforma integra herramientas para capacitación, gestión del talento
            y automatización de procesos, facilitando el crecimiento y la eficiencia
            dentro de instituciones educativas y organizaciones.
          </p>
        </header>

        <Zoom cascade damping={0.08} triggerOnce>
          <div className="service-grid">

            {modulos.map((m) => (
              <article
                key={m.id}
                className={`service-card ${
                  m.destacado ? "service-card-featured" : ""
                }`}
              >
                <div className="service-image">
                  <img src={m.imagen} alt={m.titulo} />
                </div>

                <div className="service-content">
                  <h3>{m.titulo}</h3>
                  <p>{m.descripcion}</p>

                  <ul className="service-features">
                    {m.features.map((f, i) => (
                      <li key={i}>
                        <i className="bx bx-check"></i> {f}
                      </li>
                    ))}
                  </ul>

                  {m.destacado && (
                    <button className="service-btn-secondary">
                      Conocer plataforma
                    </button>
                  )}
                </div>
              </article>
            ))}

          </div>
        </Zoom>

      </div>

    </section>
    <Footer/>
    </>
  );
}

export default ModulosPlataforma;